/* ============================================================
   LEARTS - CUSTOM PRODUCT VARIANT SWATCH FIX
   Does NOT modify theme.js
   ============================================================ */

(function ($) {
  'use strict';

  function initCustomVariantSwatches() {

    var $forms = $('#AddToCartForm');

    if (!$forms.length) {
      $forms = $('form[action*="/cart/add"]');
    }

    $forms.each(function () {

      var $form = $(this);
      var $variantSelect = $form.find('#product-selectors');

      if (!$variantSelect.length) {
        $variantSelect = $('#product-selectors');
      }

      if (!$variantSelect.length) {
        return;
      }

      /*
       * Prevent duplicate initialization
       */
      if ($form.data('custom-swatch-initialized')) {
        return;
      }

      $form.data('custom-swatch-initialized', true);


      /* ======================================================
         GET VARIANT DATA
         ====================================================== */

      var variants = [];

      /*
       * Try Shopify product JSON
       */
      var $productJson = $('#ProductJson-' + ($form.attr('id') || ''));

      if ($productJson.length) {
        try {
          var productData = JSON.parse($productJson.html());

          if (productData && productData.variants) {
            variants = productData.variants;
          }
        } catch (e) {
          console.log('Custom swatch: Product JSON error', e);
        }
      }


      /*
       * Try generic product JSON
       */
      if (!variants.length) {

        $('[type="application/json"]').each(function () {

          var text = $(this).html();

          if (!text) {
            return;
          }

          try {

            var json = JSON.parse(text);

            if (
              json &&
              json.variants &&
              Array.isArray(json.variants)
            ) {
              variants = json.variants;
              return false;
            }

          } catch (e) {}

        });

      }


      /* ======================================================
         BUILD VARIANT DATA FROM SELECT
         ====================================================== */

      if (!variants.length) {

        $variantSelect.find('option').each(function () {

          var $option = $(this);

          if ($option.is(':disabled')) {
            return;
          }

          var variantId = $option.val();

          if (!variantId) {
            return;
          }

          var title = $.trim(
            $option.text()
              .replace(/\s*-\s*Sold out\s*$/i, '')
              .replace(/\s*-\s*Unavailable\s*$/i, '')
          );

          var optionValues = title.split(' / ');

          variants.push({
            id: variantId,
            title: title,
            options: optionValues,
            available: !$option.is(':disabled')
          });

        });

      }


      if (!variants.length) {
        console.log('Custom swatch: No variants found.');
        return;
      }


      /* ======================================================
         GET CURRENT SELECTED OPTIONS
         ====================================================== */

      function getSelectedOptions() {

        var selected = [];

        $form.find('.swatch[data-option-index]').each(function () {

          var $swatch = $(this);

          var index = parseInt(
            $swatch.attr('data-option-index'),
            10
          );

          var $checked = $swatch.find(
            'input[type="radio"]:checked'
          );

          if ($checked.length) {
            selected[index] = $checked.val();
          }

        });

        return selected;
      }


      /* ======================================================
         FIND MATCHING VARIANT
         ====================================================== */

      function findVariant(selectedOptions) {

        var matched = null;

        $.each(variants, function (index, variant) {

          if (!variant.options) {
            return;
          }

          var matches = true;

          for (var i = 0; i < selectedOptions.length; i++) {

            if (
              selectedOptions[i] !== undefined &&
              selectedOptions[i] !== null &&
              selectedOptions[i] !== ''
            ) {

              if (
                String(variant.options[i]) !==
                String(selectedOptions[i])
              ) {
                matches = false;
                break;
              }

            }

          }

          if (matches) {
            matched = variant;
            return false;
          }

        });

        return matched;
      }


      /* ======================================================
         UPDATE SWATCH ACTIVE STATE
         ====================================================== */

      function updateSwatchActiveStates() {

        $form.find('.swatch[data-option-index]').each(function () {

          var $swatch = $(this);

          $swatch
            .find('.swatch-element')
            .removeClass('active selected');

          $swatch
            .find('input[type="radio"]:checked')
            .closest('.swatch-element')
            .addClass('active selected');

        });

      }


      /* ======================================================
         UPDATE AVAILABLE / SOLD OUT SWATCHES
         ====================================================== */

      function updateSwatchAvailability() {

        var selectedOptions = getSelectedOptions();

        $form.find('.swatch[data-option-index]').each(function () {

          var $swatch = $(this);

          var currentIndex = parseInt(
            $swatch.attr('data-option-index'),
            10
          );

          $swatch.find('.swatch-element').each(function () {

            var $element = $(this);
            var $radio = $element.find('input[type="radio"]');

            if (!$radio.length) {
              return;
            }

            var testValue = $radio.val();

            var testOptions = selectedOptions.slice();

            testOptions[currentIndex] = testValue;

            /*
             * Find an available variant that matches
             * the currently selected options.
             */
            var available = false;

            $.each(variants, function (i, variant) {

              if (!variant.options) {
                return;
              }

              var matches = true;

              for (
                var optionIndex = 0;
                optionIndex < testOptions.length;
                optionIndex++
              ) {

                if (
                  testOptions[optionIndex] !== undefined &&
                  testOptions[optionIndex] !== ''
                ) {

                  if (
                    String(variant.options[optionIndex]) !==
                    String(testOptions[optionIndex])
                  ) {
                    matches = false;
                    break;
                  }

                }

              }

              if (
                matches &&
                (
                  variant.available === true ||
                  variant.available === undefined
                )
              ) {
                available = true;
                return false;
              }

            });


            if (available) {

              $element
                .removeClass('soldout')
                .addClass('available');

              $radio.prop('disabled', false);

            } else {

              /*
               * Don't disable the currently selected value.
               */
              if (!$radio.is(':checked')) {

                $element
                  .removeClass('available')
                  .addClass('soldout');

                $radio.prop('disabled', true);

              }

            }

          });

        });

      }


      /* ======================================================
         UPDATE PRODUCT SELECT
         ====================================================== */

      function selectVariant(variant) {

        if (!variant || !variant.id) {
          return;
        }

        var variantId = String(variant.id);

        /*
         * Change hidden Shopify variant selector
         */
        $variantSelect.val(variantId);

        /*
         * Trigger normal Shopify / Learts change event
         */
        $variantSelect.trigger('change');

        /*
         * Also trigger input event for themes that listen
         * for input rather than change.
         */
        $variantSelect.trigger('input');

        /*
         * Update URL without reloading page
         */
        try {

          var url = new URL(window.location.href);

          url.searchParams.set('variant', variantId);

          window.history.replaceState(
            {},
            '',
            url.toString()
          );

        } catch (e) {}

      }


      /* ======================================================
         UPDATE PRICE
         ====================================================== */

      function updatePrice(variant) {

        if (!variant || variant.price === undefined) {
          return;
        }

        /*
         * Let Learts handle price first.
         */
        $variantSelect.trigger('variant:changed', [variant]);

        /*
         * If Shopify.formatMoney exists,
         * update the standard Learts price.
         */
        if (
          typeof Shopify !== 'undefined' &&
          typeof Shopify.formatMoney === 'function'
        ) {

          var moneyFormat =
            window.money_format ||
            window.themeMoneyFormat ||
            '{{amount}}';

          var formattedPrice =
            Shopify.formatMoney(
              variant.price,
              moneyFormat
            );

          $('#ProductPrice').html(formattedPrice);

          /*
           * Common Learts price selectors
           */
          $('.product-price #ProductPrice').html(formattedPrice);
          $('.product-single__price #ProductPrice').html(formattedPrice);

        }

        /*
         * Compare price
         */
        if (
          variant.compare_at_price &&
          Number(variant.compare_at_price) >
          Number(variant.price)
        ) {

          if (
            typeof Shopify !== 'undefined' &&
            typeof Shopify.formatMoney === 'function'
          ) {

            var compareFormat =
              window.money_format ||
              window.themeMoneyFormat ||
              '{{amount}}';

            var comparePrice =
              Shopify.formatMoney(
                variant.compare_at_price,
                compareFormat
              );

            $('#ComparePrice')
              .html(comparePrice)
              .show();

          }

        } else {

          $('#ComparePrice').hide();

        }

      }


      /* ======================================================
         UPDATE ADD TO CART
         ====================================================== */

      function updateAddToCart(variant) {

        var $button = $('#AddToCart');

        if (!$button.length) {
          $button = $form.find(
            'button[type="submit"], input[type="submit"]'
          );
        }

        if (!variant) {

          $button
            .addClass('disabled')
            .prop('disabled', true);

          return;
        }


        if (variant.available === false) {

          $button
            .addClass('disabled')
            .prop('disabled', true);

          $('#AddToCartText').html(
            window.AddTocart &&
            window.AddTocart.soldout
              ? window.AddTocart.soldout
              : 'Sold Out'
          );

        } else {

          $button
            .removeClass('disabled')
            .prop('disabled', false);

          $('#AddToCartText').html(
            window.AddTocart &&
            window.AddTocart.CartTitle
              ? window.AddTocart.CartTitle
              : 'Add to Cart'
          );

        }

      }


      /* ======================================================
         UPDATE PRODUCT IMAGE
         ====================================================== */

      function updateImage(variant) {

        if (!variant) {
          return;
        }

        var imageSrc = null;

        /*
         * Shopify product JSON image
         */
        if (
          variant.featured_image &&
          variant.featured_image.src
        ) {

          imageSrc = variant.featured_image.src;

        } else if (variant.image) {

          imageSrc = variant.image;

        }


        /*
         * Try swatch data image
         */
        if (!imageSrc) {

          var selectedSwatch =
            $form.find(
              '.swatch-element input[type="radio"]:checked'
            ).closest('.swatch-element');

          var $label =
            selectedSwatch.find('label');

          if ($label.length) {

            var dataSrc =
              $label.attr('data-src');

            if (dataSrc) {
              imageSrc = dataSrc;
            }

          }

        }


        if (!imageSrc) {
          return;
        }


        /*
         * Main Learts product image
         */
        var $mainImages = $(
          "img[id|='product-featured-image'], " +
          ".product_media_gallery img, " +
          ".product-single__photo img, " +
          ".product-gallery img"
        );


        $mainImages.each(function () {

          var $img = $(this);

          /*
           * Don't destroy srcset unnecessarily
           */
          $img.attr('src', imageSrc);

          if ($img.attr('srcset')) {
            $img.attr('srcset', imageSrc);
          }

        });


        /*
         * Learts Shopify image switch
         */
        if (
          typeof Shopify !== 'undefined' &&
          Shopify.Image &&
          typeof Shopify.Image.switchImage === 'function'
        ) {

          var $productImage =
            $("img[id|='product-featured-image']");

          if ($productImage.length) {

            try {

              Shopify.Image.switchImage(
                imageSrc,
                $productImage[0],
                function (src) {
                  $productImage.attr('src', src);
                }
              );

            } catch (e) {}

          }

        }

      }


      /* ======================================================
         SWATCH CLICK / CHANGE
         ====================================================== */

      $form
        .off('change.customVariantSwatch')
        .on(
          'change.customVariantSwatch',
          '.swatch input[type="radio"]',
          function () {

            var $radio = $(this);

            if ($radio.is(':disabled')) {
              return;
            }

            var selectedOptions =
              getSelectedOptions();

            var variant =
              findVariant(selectedOptions);


            /*
             * If exact variant doesn't exist,
             * don't change the current Shopify variant.
             */
            if (!variant) {

              updateSwatchActiveStates();
              updateSwatchAvailability();

              return;
            }


            /*
             * Select Shopify variant
             */
            selectVariant(variant);


            /*
             * Update interface
             */
            updateSwatchActiveStates();
            updateSwatchAvailability();
            updatePrice(variant);
            updateAddToCart(variant);
            updateImage(variant);

          }
        );


      /* ======================================================
         INITIALIZE CURRENT VARIANT
         ====================================================== */

      function initializeCurrentVariant() {

        var currentVariantId =
          $variantSelect.val();

        var currentVariant = null;

        $.each(variants, function (i, variant) {

          if (
            String(variant.id) ===
            String(currentVariantId)
          ) {

            currentVariant = variant;
            return false;

          }

        });


        /*
         * If current variant found,
         * select its swatches.
         */
        if (
          currentVariant &&
          currentVariant.options
        ) {

          $form.find(
            '.swatch[data-option-index]'
          ).each(function () {

            var $swatch = $(this);

            var index =
              parseInt(
                $swatch.attr('data-option-index'),
                10
              );

            var value =
              currentVariant.options[index];

            if (value === undefined) {
              return;
            }

            $swatch
              .find(
                'input[type="radio"]'
              )
              .filter(function () {
                return $(this).val() === value;
              })
              .prop('checked', true);

          });

        }


        updateSwatchActiveStates();
        updateSwatchAvailability();

      }


      initializeCurrentVariant();


      /* ======================================================
         ALSO WATCH NORMAL SELECT CHANGES
         ====================================================== */

      $variantSelect
        .off('change.customVariantSync')
        .on(
          'change.customVariantSync',
          function () {

            var variantId = $(this).val();

            var variant = null;

            $.each(variants, function (i, item) {

              if (
                String(item.id) ===
                String(variantId)
              ) {

                variant = item;
                return false;

              }

            });


            if (!variant) {
              return;
            }


            /*
             * Keep swatches synchronized
             */
            if (variant.options) {

              $form.find(
                '.swatch[data-option-index]'
              ).each(function () {

                var $swatch = $(this);

                var index =
                  parseInt(
                    $swatch.attr('data-option-index'),
                    10
                  );

                var value =
                  variant.options[index];

                $swatch
                  .find(
                    'input[type="radio"]'
                  )
                  .filter(function () {
                    return $(this).val() === value;
                  })
                  .prop('checked', true);

              });

            }


            updateSwatchActiveStates();
            updateSwatchAvailability();

          }
        );

    });

  }


  /* ==========================================================
     INITIAL LOAD
     ========================================================== */

  $(document).ready(function () {

    initCustomVariantSwatches();

  });


  /* ==========================================================
     SHOPIFY THEME EDITOR
     ========================================================== */

  $(document).on(
    'shopify:section:load',
    function () {

      setTimeout(function () {
        initCustomVariantSwatches();
      }, 300);

    }
  );


})(jQuery);